import config from '../config';

class Boot extends Phaser.Scene {
  init () {
    // console.log('Boot.init');
    let g = this;

    // apply our styles defined in the head of index.html

    // initialize our global pause and resume functionality
    g.sys.game.dataManager.setSessionItem(config.BASE_SCENE, 'Boot');
  }
  preload () {
    let g = this;

    g.load.path = config.MEDIA_IMAGE_PATH;

    g.load.image('loader-bg', 'loader/bg.png');
    g.load.image('loader-tape', 'loader/tape.png');

    g.load.path = config.MEDIA_FONT_PATH;
    
    g.load.path = config.CONFIG_PATH;
    g.load.json('config', "config.json");

    g.load.path = config.MEDIA_DATA_PATH;

    g.load.json('localisation', "localisation.json");
    
  }
  create () {

    this.sys.game.localisationManager.SetLocalisationData(this.cache.json.get('config').language, this.cache.json.get('localisation'));
    this.scene.start('Preload');
  }
}

export default Boot;
